import { useQuery } from 'react-query';
import axios from 'axios';
import { MINUTE } from 'time-constants';

import { apiConfig } from '@constants';

const getTileInventory = async () => {
  const { data } = await axios.get(
    `${apiConfig.TWC_API_BASE}${apiConfig.TWC_API_MAP_TILE_INVENTORY}?apiKey=${apiConfig.TWC_API_MAP_TILE_KEY}`,
  );

  return data;
};

export const useGetTileInventory = () =>
  useQuery('getTileInventory', () => getTileInventory(), {
    refetchInterval: 5 * MINUTE,
    refetchOnWindowFocus: false,
  });
